/**
 * Heading utilities for rule file transformations
 *
 * Used when merging multiple rule files into a single file (e.g., AGENTS.md)
 * and when extracting body content from frontmatter-based files.
 */

/**
 * Reduce heading levels by 1 (# → ##, ## → ###, etc.)
 * Used when merging multiple subfiles into a single AGENTS.md
 * so that the top-level heading of AGENTS.md remains unique.
 *
 * Max depth is 5 (#####), so h5 becomes h6.
 */
export function downshiftHeadings(content: string): string {
    return content.replace(/^(#{1,5})\s/gm, (_match, hashes: string) => '#' + hashes + ' ');
}

/**
 * Extract body content by stripping YAML frontmatter.
 * Returns the trimmed content after the closing `---`.
 * If no frontmatter is found, returns the original trimmed content.
 */
export function extractBody(content: string): string {
    const match = content.match(/^---\n[\s\S]*?\n---\n?([\s\S]*)$/);
    return match ? match[1]!.trim() : content.trim();
}
